import { createSlice } from "@reduxjs/toolkit";
import retrieveConfigs from "../../utils/heatmap/retrieveConfigs";
import LocalStorage from "../../utils/localStorage";

const heatMapConfigsSlice = createSlice({
  name: "heatMapConfigs",
  initialState: {
    configs: retrieveConfigs(),
    selectedConfig: "",
  },
  reducers: {
    setHeatMapConfigs: (state, action) => {
      state.configs = action.payload;
    },
    setHeatMapSelectedConfig: (state, action) => {
      state.selectedConfig = action.payload;
    },
  },
});

export const { setHeatMapConfigs, setHeatMapSelectedConfig } =
  heatMapConfigsSlice.actions;

export default heatMapConfigsSlice.reducer;

export const addHeatMapConfig = (newName, payload) => (dispatch, getState) => {
  const configsCopy = [...getState().heatMapConfigs.configs];
  const index = configsCopy.findIndex(({ name }) => name === newName);

  const newConfig = {
    name: newName,
    ...payload,
  };

  if (index < 0) {
    configsCopy.push(newConfig);
  } else {
    configsCopy[index] = newConfig;
  }

  dispatch(setHeatMapConfigs(configsCopy));
  const customConfigs = configsCopy.filter((config) => !config.preset);
  console.log(JSON.stringify(customConfigs));
  LocalStorage.setCustomHeatMapConfigurations(customConfigs);
};

export const deleteHeatMapConfig = (configToDelete) => (dispatch, getState) => {
  const configsCopy = [...getState().heatMapConfigs.configs];

  const index = configsCopy.findIndex(
    (config) => config.name === configToDelete.name
  );
  if (index > -1) {
    configsCopy.splice(index, 1);
  }

  dispatch(setHeatMapConfigs(configsCopy));
  const customConfigs = configsCopy.filter((config) => !config.preset);
  LocalStorage.setCustomHeatMapConfigurations(customConfigs);
};

export const overrideHeatMapConfig =
  (configToOverride, payload) => (dispatch, getState) => {
    const configsCopy = [...getState().heatMapConfigs.configs];

    configsCopy[configToOverride] = {
      ...configsCopy[configToOverride],
      ...payload,
    };

    dispatch(setHeatMapConfigs(configsCopy));
    const customConfigs = configsCopy.filter((config) => !config.preset);
    LocalStorage.setCustomHeatMapConfigurations(customConfigs);
  };

export const updateConfigChartStudies =
  (configToUpdate, newChartStudies) => (dispatch, getState) => {
    const configsCopy = [...getState().heatMapConfigs.configs];

    configsCopy[configToUpdate] = {
      ...configsCopy[configToUpdate],
      chartStudies: newChartStudies,
    };
    dispatch(setHeatMapConfigs(configsCopy));
    const customConfigs = configsCopy.filter((config) => !config.preset);
    LocalStorage.setCustomHeatMapConfigurations(customConfigs);
  };
